import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  OnDestroy,
  ViewChild,
  ElementRef,
  Renderer2
} from "@angular/core";
import { ConfigService } from "../services/config.service";
import { Subscription } from "rxjs";
import { CustomizerService } from '../services/customizer.service';

@Component({
  selector: "app-customizer",
  templateUrl: "./customizer.component.html",
  styleUrls: ["./customizer.component.scss"]
})
export class CustomizerComponent implements OnInit, OnDestroy {
  @ViewChild("customizer") customizer: ElementRef;
  configSub: Subscription;
  bgColor: string;

  size: string;
  isBgImageDisplay: boolean = true;
  isOpen = true;
  public config: any = {};
  layoutSub: Subscription;

  constructor(
    private renderer: Renderer2,
    private configService: ConfigService,
    public customizerService: CustomizerService,
  ) {

    this.config = this.configService.templateConf;
    this.isOpen = !this.config.layout.customizer.hidden;

    if (this.config.layout.sidebar.size) {
      this.size = this.config.layout.sidebar.size;
    }
  }

  @Output() directionEvent = new EventEmitter<Object>();

  ngOnInit() {
    this.configSub = this.configService.templateConf$.subscribe((templateConf) => {
      if (templateConf) {
        this.config = templateConf;
        if (!this.config.layout.sidebar.backgroundColor) {
          this.bgColor = this.customizerService.light_dark_colors[7].code;
        } else {
          this.bgColor = this.config.layout.sidebar.backgroundColor;
        }
        let colorcode = '';
        if (this.bgColor == "mint") {
          colorcode = 'rgb(31 88 155)';
        }
        else if (this.bgColor == "king-yna") {
          colorcode = "#975aff";
        }
        else if (this.bgColor == "ibiza-sunset") {
          colorcode = "rgb(183 83 69)";
        }
        else if (this.bgColor == "flickr") {
          colorcode = "rgb(152 101 78)";
        }
        else if (this.bgColor == "purple-bliss") {
          colorcode = "rgb(53 86 190)";
        }
        else if (this.bgColor == "man-of-steel") {
          colorcode = "rgb(103 58 110)";
        }
        else if (this.bgColor == "purple-love") {
          colorcode = "rgb(136 96 213)";
        }
        else if (this.bgColor == "black") {
          colorcode = "black";
        }
        else if (this.bgColor == "white") {
          colorcode = "rgb(47 139 230)";
        }
        else if (this.bgColor == "primary") {
          colorcode = "rgb(116 65 219)";
        }
        else if (this.bgColor == "success") {
          colorcode = "#2ea54f";
        }
        else if (this.bgColor == "warning") {
          colorcode = "#d46010";
        }
        else if (this.bgColor == "info") {
          colorcode = "rgb(34, 108, 197)";
        }
        else if (this.bgColor == "danger") {
          colorcode = "#d23b48";
        }
        else {
          colorcode = "rgb(47, 139, 230)";
        }
        localStorage.setItem('Color-Changer', this.bgColor);
        localStorage.setItem('img-Changer', this.config.layout.sidebar.backgroundImageURL);
        localStorage.setItem('Btn-Color-Changer', colorcode);
        if (!(document.getElementById('customizerstyle') == undefined || document.getElementById('customizerstyle') == null)) {
          document.getElementById('customizerstyle').remove();
        } (document.getElementsByTagName('head')[0]).innerHTML += `<style id="customizerstyle">.btn-info, .bg-info-new, .active-info:active{background-color:${colorcode} !important} ul.nav.nav-tabs a{color:${colorcode} !important;border-color:${colorcode} !important}</style>`;
      }
    });
  }


  changeSidebarWidth(value) {
    this.size = value;
    this.customizerService.changeSidebarWidth(value);
  }

  toggleCustomizer() {
    if (this.isOpen) {
      this.renderer.removeClass(this.customizer.nativeElement, "open");
      this.isOpen = false;
    } else {
      this.renderer.addClass(this.customizer.nativeElement, "open");
      this.isOpen = true;
    }
  }

  closeCustomizer() {
    this.renderer.removeClass(this.customizer.nativeElement, "open");
    this.isOpen = false;
  }

  bgImageDisplay(e) {
    if (e.target.checked) {
      this.isBgImageDisplay = true;
    } else {
      this.isBgImageDisplay = false;
    }
    //emit event to FUll Layout
    this.customizerService.bgImageDisplay(e);
  }


  ngOnDestroy() {
    if (this.layoutSub) {
      this.layoutSub.unsubscribe();
    }
  }


}
